// @ts-nocheck
import {
    canAddToCart,
    getProductsDataView,
    getProductState,
    getProductStateByPath,
    getVariantChildrenDataView,
    hasEnoughInventory,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";

export const useProductState = convertSelectorToHook(getProductState);
export const useProductStateByPath = convertSelectorToHook(getProductStateByPath);
export const useVariantChildrenDataView = convertSelectorToHook(getVariantChildrenDataView);
export const useProductsDataView = convertSelectorToHook(getProductsDataView);
export const useCanAddToCart = convertSelectorToHook(canAddToCart);
export const useHasEnoughInventory = convertSelectorToHook(hasEnoughInventory);
